import { useMutation } from "@apollo/client";

import { ProtocolCreateInput } from "~/__generated__";

import { ProtocolCreateRoute_CreateDocument } from "../mutations.generated";

export default function useProtocolCreateRoute_Create() {
    const [createProtocol, { data, loading, error }] = useMutation(ProtocolCreateRoute_CreateDocument);

    const create = (input: ProtocolCreateInput) =>
        createProtocol({
            variables: { input },
        });

    return {
        createProtocol: create,
        loading,
        error,
        data: data?.protocolCreate,
    };
}
